// LOS CAMPOS DEL MEDICAMENTO, COMO SE DIBUJAN EN LA PANTALLA.
//
// Lissette, 2026-10-15: *"un buscador de medicina y poder guardarlo en los
// clientes [...] que el sistema lo reconozca, se lo complete y le dé
// sugerencias, y también de dosis"*.
//
// ESTA LISTA ES LA MISMA QUE LA DEL SERVIDOR: `deskte-api/src/utils/
// medicamentosDelCliente.ts` lleva `CAMPOS_DEL_MEDICAMENTO` y `LARGO_MAXIMO`
// con estos mismos nombres y topes, y `tests/unit/medicamentosDelCliente.test.ts`
// compara los dos ficheros. Un campo que el formulario mande y el servidor no
// recoja se guardaria en el aire sin dar ningun error (la trampa de `pickData`).

export const CAMPOS_DEL_MEDICAMENTO = [
  'nombre',
  'rxcui',
  'dosis',
  'frecuencia',
  'recetadoPor',
  'notas',
];

export const LARGO_MAXIMO = {
  nombre: 200,
  rxcui: 20,
  dosis: 120,
  frecuencia: 120,
  recetadoPor: 160,
  notas: 2000,
};

export const ETIQUETAS = {
  nombre: { es: 'Medicamento', en: 'Medication' },
  dosis: { es: 'Dosis', en: 'Dose' },
  frecuencia: { es: '¿Cada cuánto?', en: 'How often?' },
  recetadoPor: { es: 'Recetado por', en: 'Prescribed by' },
  notas: { es: 'Notas', en: 'Notes' },
};

/**
 * Las formas de tomarlo que más se escriben. Son SUGERENCIAS (una lista del
 * navegador debajo del campo): se puede escribir cualquier otra cosa.
 */
export const FRECUENCIAS = {
  es: [
    '1 vez al día', '2 veces al día', '3 veces al día', '4 veces al día',
    'Cada mañana', 'Cada noche', 'Cada 8 horas', 'Cada 12 horas',
    '1 vez a la semana', '1 vez al mes', 'Cuando lo necesita',
  ],
  en: [
    'Once a day', 'Twice a day', '3 times a day', '4 times a day',
    'Every morning', 'Every night', 'Every 8 hours', 'Every 12 hours',
    'Once a week', 'Once a month', 'As needed',
  ],
};

/** El formulario vacio: todas las claves a "" (nunca `undefined`). */
export function medicamentoVacio(persona = 'primary') {
  const o = { persona };
  for (const c of CAMPOS_DEL_MEDICAMENTO) o[c] = '';
  return o;
}

/** Un medicamento que vino del servidor, como formulario. */
export function medicamentoComoFormulario(m) {
  const o = medicamentoVacio((m && m.persona) || 'primary');
  for (const c of CAMPOS_DEL_MEDICAMENTO) o[c] = (m && m[c]) || '';
  return o;
}

/** "500 mg Tab · 2 veces al día": lo de debajo del nombre en la lista. */
export function resumenDelMedicamento(m) {
  if (!m) return '';
  return [(m.dosis || '').trim(), (m.frecuencia || '').trim()].filter(Boolean).join(' · ');
}

/**
 * Elegir un medicamento de la busqueda: pone el nombre y, si solo existe UNA
 * presentacion, tambien la dosis y su codigo. Con varias, la dosis se deja
 * para que la elija la agente (adivinarla seria peor que dejarla vacia).
 * El codigo de un nombre sin dosis elegida no se guarda: el codigo RxNorm es
 * de cada PRESENTACION, no del nombre.
 */
export function aplicarSugerencia(form, sugerencia) {
  const pres = (sugerencia && sugerencia.presentaciones) || [];
  const unica = pres.length === 1 ? pres[0] : null;
  return {
    ...form,
    nombre: (sugerencia && sugerencia.nombre) || form.nombre,
    dosis: unica ? unica.dosis : '',
    rxcui: unica ? unica.rxcui || '' : '',
  };
}

/** Elegir una de las dosis sugeridas: la dosis y el codigo de ESA presentacion. */
export function aplicarDosis(form, presentacion) {
  return { ...form, dosis: presentacion.dosis, rxcui: presentacion.rxcui || '' };
}

/**
 * Escribir el nombre a mano despues de haber elegido uno de la busqueda: el
 * codigo ya no corresponde a lo escrito y se suelta. Guardar "Ozempic" con el
 * codigo de la metformina seria peor que no guardar ninguno.
 */
export function escribirNombre(form, texto) {
  return { ...form, nombre: texto, rxcui: '' };
}

/** Escribir la dosis a mano: igual, el codigo era el de la sugerida. */
export function escribirDosis(form, texto) {
  return { ...form, dosis: texto, rxcui: '' };
}
